import { render, staticRenderFns } from "./HistorialClinico.vue?vue&type=template&id=3a7c8d36&"
import script from "./HistorialClinico.vue?vue&type=script&lang=js&"
export * from "./HistorialClinico.vue?vue&type=script&lang=js&"
import style0 from "./HistorialClinico.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCardText,VStepper,VStepperContent,VStepperStep})
